import SearchContent from './SearchContent'

export default SearchContent
